module.exports = __webpack_public_path__ + "media/images/ping/red-82b088a36104dc299c52f9fc56604793.png";